import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sbaAxios } from '../../../utils/sbaAxios';
import {
  getAssetsListDataAction,
  getExposureTsOptionEquityChartAction,
  getExposureTsCurrentSectorChartAction,
  getExposureTsSectorNoOpChartAction,
  getExposureTsSectorChartAction,
} from "../../../actions/publicExposureAction";
import { getPublicExposureMinMaxAssetDates } from "../../../../config/apiConfig";
import { DateRangePicker } from "rsuite";
import moment from "moment";
import { TileLayout } from "@progress/kendo-react-layout";
import {
  Chart,
  ChartLegend,
  ChartTitle,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartValueAxis,
  ChartValueAxisItem,
  ChartCategoryAxisTitle,
  ChartCategoryAxisLabels,
  ChartSeries,
  ChartSeriesItem,
} from "@progress/kendo-react-charts";
import { getAssestListddlAction } from "../../../actions/assetsddlAction";
import { SBAComboBox } from "../../../UiComponents/SBADropDown";
import { UrlPath } from "../../../../config/routeConfig";
import { useNavigate } from "react-router";
import { SBDateRangePicker } from "../../../UiComponents/SBDateRangePicker";

export const ChartFilters = ({AssetParams}) => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const [selectedAsset, setSelectedAsset] = useState(AssetParams);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [selectedOption, setSelectedOption] = useState(true);
  const [widgetView, setWidgetView] = useState(false);
  const [areaChartEquityOnly, setAreaChartEquityOnlyActive] = useState(true);
  const [stackBarChartEquityOnly, setStackBarChartEquityOnlyActive] = useState(false);
  const [areaChartSector, setAreaChartSectorActive] = useState(true);
  const [stackBarChartSector, setStackBarChartSectorActive] = useState(false);

  useEffect(() => {
    const assetListData = async () => {
      dispatch(getAssetsListDataAction("", ""));
    };
    dispatch(getAssestListddlAction());
    assetListData();
  }, []);

  useEffect(() => {
    setSelectedAsset(AssetParams);
  }, [AssetParams]);

  useEffect(() => {
    const getMinMaxDates = async () => {
      if (selectedAsset.AssetId) {
        try {
            const response = await sbaAxios({
                url: `${getPublicExposureMinMaxAssetDates}${selectedAsset.AssetId}`,
                method: 'get',
            })
          const MinMaxDateValue = {
            MinDate: response.MinDate,
            MaxDate: response.MaxDate,
          };
          if (
            MinMaxDateValue.MinDate !== null &&
            MinMaxDateValue.MaxDate !== null
          ) {
            setStartDate(MinMaxDateValue.MinDate);
            setEndDate(MinMaxDateValue.MaxDate);
          }
        } catch (error) {
          console.error("Error fetching MinMaxValues from API:", error);
        }
      }
    };

    getMinMaxDates();
    enterButtonClick();
  }, [selectedAsset]);

  const Gstate =
    useSelector((state) => {
      return state;
    }) || {};

  const assetsListGrid = Gstate?.PublicExposure?.PublicExposureAssetsList;
  const AssetListDDL = Gstate.assetDDL.assetList || [];

  const assetsListGridRowData = Array.isArray(assetsListGrid)
    ? assetsListGrid.map((row) => {
        const rowDataItem = {
          AssetId: row.AssetId,
          AssetName: row.AssetName,
        };
        return rowDataItem;
      })
    : [];

    const AssestDDChanged = (e) => {
      if(e.value)
      {
        history(`${UrlPath.PublicExposure}${e.value.AssetId}`);
          setSelectedAsset(e.value);
          setWidgetView(false);
      }
  };

  const handleDateChange = (e) => {
    if(e)
    {
        const newStartDate = e.value.start !== null ? e.value.start : startDate;
        const newEndDate = e.value.end !== null ? e.value.end : endDate;
        setStartDate(newStartDate)
        setEndDate(newEndDate)
    }
  };

  //Enter to generate chart
    const enterButtonClick = () => {
    const formattedStartDate = moment(startDate).format("MM-DD-YYYY");
    const formattedEndDate = moment(endDate).format("MM-DD-YYYY");
    if (selectedAsset.AssetId !== null) {
      dispatch(
        getExposureTsCurrentSectorChartAction(
          selectedAsset.AssetId,
          formattedStartDate,
          formattedEndDate,
          "Current_Sector",
          0,
          0,
          1
        )
      );
      dispatch(
        getExposureTsOptionEquityChartAction(
          selectedAsset.AssetId,
          formattedStartDate,
          formattedEndDate,
          "Option_Equity",
          1,
          0,
          1
        )
      );
      dispatch(
        getExposureTsSectorNoOpChartAction(
          selectedAsset.AssetId,
          formattedStartDate,
          formattedEndDate,
          "Sector_No_Op",
          0,
          0,
          1
        )
      );
      dispatch(
        getExposureTsSectorChartAction(
          selectedAsset.AssetId,
          formattedStartDate,
          formattedEndDate,
          "Sector",
          0,
          0,
          1
        )
      );
    }
    setWidgetView(true);
  };

  //Clear All
  const clearButtonClick = (e) => {
    setSelectedAsset([""]);
    setStartDate(new Date());
    setEndDate(new Date());
    setWidgetView(false);
  };

  //onchange toggle charts
  const toggleButton = (buttonName) => {
    switch (buttonName) {
      case "areaChartEquityOnly":
        setAreaChartEquityOnlyActive(true);
        setStackBarChartEquityOnlyActive(false);
        break;
      case "stackBarChartEquityOnly":
        setAreaChartEquityOnlyActive(false);
        setStackBarChartEquityOnlyActive(true);
        break;     
        case "areaChartSector":
          setAreaChartSectorActive(true);
          setStackBarChartSectorActive(false);
          break;
        case "stackBarChartSector":
          setAreaChartSectorActive(false);
          setStackBarChartSectorActive(true);
          break;     
    }
  };

  const [data, setData] = React.useState([
    {
      col: 1,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 3,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 1,
      colSpan: 2,
      rowSpan: 2,
    },
    {
      col: 3,
      colSpan: 2,
      rowSpan: 2,
    },
  ]);

  //CurrentSectorChart
  const CurrentSectorChart = Gstate?.PublicExposure?.CurrentSectorChart || [];
  const CurrentSectorData =
    CurrentSectorChart.length > 0 ? CurrentSectorChart[0] : {};
  const CurrentSectorCategories = CurrentSectorData.SectorName || [];
  const CurrentSectorReportValue = CurrentSectorData.ReportValue || [];

  //EquityChart
    const EquityChart = Gstate?.PublicExposure?.EquityChart || [];
    const EquityChartCategories = EquityChart[0]?.ReportDateString || [];
    const EquityChartData = Array.isArray(EquityChart)
        ? EquityChart.map((item) => ({
            name: item.CategoryName,
            data: item.ReportValue,
            color: item.CategoryColor,
        }))
        : [];

  //SectorNoOpChart
  const SectorNoOpChart = Gstate?.PublicExposure?.SectorNoOpChart || [];

  const sectorNoOpChartCategories = SectorNoOpChart[0]?.ReportDateString || [];
  const sectorNoOpChartSeriesData = Array.isArray(SectorNoOpChart)
    ? SectorNoOpChart.map((item) => ({
        name: item.CategoryName,
        data: item.ReportValue,
        color: item.CategoryColor,
      }))
    : [];

  //SectorChart
  const SectorChart = Gstate?.PublicExposure?.SectorChart || [];
  const sectorChartCategories = SectorChart[0]?.ReportDateString || [];
  const sectorChartSeriesData = Array.isArray(SectorChart)
  ? SectorChart.map((item) => ({
      name: item.CategoryName,
      data: item.ReportValue,
      color: item.CategoryColor,
    }))
  : [];

   
  const tiles = [
      {
          
      header: (
        <div className="header-container">
          <b>
            {selectedAsset.AssetName} - 13F Fillings By Sectors (Equity Only),
            as of {moment(endDate).format("MMM-YY")}
          </b>
        </div>
      ),
      body: (
        <>
          <Chart>
            <ChartTitle />
            <ChartCategoryAxis>
              <ChartCategoryAxisItem categories={CurrentSectorCategories}>
                <ChartCategoryAxisTitle text="" />
              </ChartCategoryAxisItem>
            </ChartCategoryAxis>
            <ChartSeries>
              <ChartSeriesItem
                type="bar"
                gap={2}
                spacing={0.25}
                color={CurrentSectorChart[0]?.CategoryColor}
                data={CurrentSectorReportValue}
                tooltip={{ visible: true, format: "{0:N2}%" }}
                opacity={1}
              />
            </ChartSeries>
            <ChartValueAxis>
              <ChartValueAxisItem labels={{ format: "{0}%" }} />
            </ChartValueAxis>
          </Chart>
        </>
      ),
      reorderable: false,
    },
    {
      header: (
        <div className="header-container">
          <b>
            {selectedAsset.AssetName} - 13F Fillings Options/Equity ({" "}
            {moment(startDate).format("MMMM-YYYY")} to{" "}
            {moment(endDate).format("MMMM-YYYY")})
          </b>
        </div>
      ),
      body: (
        <>
          <Chart>
            <ChartTitle />
            <ChartCategoryAxis>
              <ChartCategoryAxisItem
                categories={EquityChartCategories}
                labels={{
                  rotation: 90,
                  position: "start",
                }}
              >
                <ChartCategoryAxisTitle text="" />
              </ChartCategoryAxisItem>
              <ChartCategoryAxisLabels rotation={90} />
            </ChartCategoryAxis>
            <ChartValueAxis>
              <ChartValueAxisItem
                name="primary"
                color="#7D7D7D"
                axisCrossingValue={[0, -100000000000000000, 0, 0]}
                labels={{ format: "{0}%", position: "right" }}
                majorGridLines={{ visible: false }}
                max={100}
                min={0}
              />
            </ChartValueAxis>
            <ChartSeries>
              {EquityChartData.map((series) => (
                <ChartSeriesItem
                  key={series.name}
                  type="area"
                  data={series.data}
                  name={series.name}
                  color={series.color}
                  tooltip={{ visible: true, format: "{0:N2}%" }}
                  opacity={1}
                />
              ))}
            </ChartSeries>
            <ChartLegend position="bottom" visible={true} />
          </Chart>
        </>
      ),
      reorderable: false,
    },
    {
      header: (
        <>
          <div className="d-flex justify-content-between">
            <b>
              {selectedAsset.AssetName} - 13F Fillings By Sectors (Equity Only),
              as of ( {moment(startDate).format("MMMM-YYYY")} to{" "}
              {moment(endDate).format("MMMM-YYYY")})
            </b>{" "}
            <div className="d-inline-flex">
              <button
                className={`toggle-btn rounded-start ${
                  areaChartEquityOnly ? "activeBtn" : "nonactiveBtn"
                }`}
                onClick={() => toggleButton("areaChartEquityOnly")}
              >
                <i className="fa-solid fa-chart-area"></i>
              </button>
              <button
                className={`toggle-btn rounded-end ${
                  stackBarChartEquityOnly ? "activeBtn" : "nonactiveBtn"
                }`}
                onClick={() => toggleButton("stackBarChartEquityOnly")}
              >
                <i class="fas fa-chart-simple"></i>
              </button>
            </div>
          </div>
        </>
      ),
      body: (
        <>
          {areaChartEquityOnly && (
            <Chart>
              <ChartTitle />
              <ChartCategoryAxis>
                <ChartCategoryAxisItem
                  categories={sectorNoOpChartCategories}
                  labels={{
                    rotation: 90,
                    position: "start",
                  }}
                />
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  axisCrossingValue={[0, -100000000000000000, 0, 0]}
                  labels={{ format: "{0}%", position: "right" }}
                  majorGridLines={{ visible: false }}
                  max={100}
                  min={0}
                />
              </ChartValueAxis>
              <ChartSeries>
                {sectorNoOpChartSeriesData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type="area"
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:N2}%" }}
                    opacity={1}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          )}
          {stackBarChartEquityOnly && (
            <Chart>
              <ChartTitle />
              <ChartCategoryAxis>
                <ChartCategoryAxisItem
                  categories={sectorNoOpChartCategories}
                  labels={{
                    rotation: 90,
                    position: "start",
                  }}
                />
              </ChartCategoryAxis>
              <ChartSeries>
                {sectorNoOpChartSeriesData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type="column"
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:N2}%" }}
                    stack={{
                      type: "100%",
                    }}
                    opacity={1}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          )}
        </>
      ),
      reorderable: false,
    },
    {
      header: (
        <>
          <div className="d-flex justify-content-between">
            <b>
              {selectedAsset.AssetName} - 13F Fillings By Sectors ({" "}
              {moment(startDate).format("MMMM-YYYY")} to{" "}
              {moment(endDate).format("MMMM-YYYY")})
            </b>
            <div className="d-inline-flex">
              <button
                className={`toggle-btn rounded-start ${
                  areaChartSector ? "activeBtn" : "nonactiveBtn"
                }`}
                onClick={() => toggleButton("areaChartSector")}
              >
                <i className="fa-solid fa-chart-area"></i>
              </button>
              <button
                className={`toggle-btn rounded-end ${
                  stackBarChartSector ? "activeBtn" : "nonactiveBtn"
                }`}
                onClick={() => toggleButton("stackBarChartSector")}
              >
                <i class="fas fa-chart-simple"></i>
              </button>
            </div>
          </div>
        </>
      ),
      body: (
        <>
          {areaChartSector && (
            <Chart>
              <ChartTitle />
              <ChartCategoryAxis>
                <ChartCategoryAxisItem
                  categories={sectorChartCategories}
                  labels={{
                    rotation: 90,
                    position: "start",
                  }}
                />
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  name="primary"
                  color="#7D7D7D"
                  axisCrossingValue={[0, -100000000000000000, 0, 0]}
                  labels={{ format: "{0}%", position: "right" }}
                  majorGridLines={{ visible: false }}
                  max={100}
                  min={0}
                />
              </ChartValueAxis>
              <ChartSeries>
                {sectorChartSeriesData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type="area"
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:N2}%" }}
                    opacity={1}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          )}

          {stackBarChartSector && (
            <Chart>
              <ChartTitle />
              <ChartCategoryAxis>
                <ChartCategoryAxisItem
                  categories={sectorChartCategories}
                  labels={{
                    rotation: 90,
                    position: "start",
                  }}
                />
              </ChartCategoryAxis>
              <ChartSeries>
                {sectorChartSeriesData.map((series) => (
                  <ChartSeriesItem
                    key={series.name}
                    type="column"
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    tooltip={{ visible: true, format: "{0:N2}%" }}
                    stack={{
                      type: "100%",
                    }}
                    opacity={1}
                  />
                ))}
              </ChartSeries>
              <ChartLegend position="bottom" visible={true} />
            </Chart>
          )}
        </>
      ),
      reorderable: false,
    },
  ];
  const handleReposition = (e) => {
    setData(e.value);
    console.log(e.value);
  };

  return (
    <>
      <form action="#">
        <div className="row flex-wrap">
          <div className="col-md-4">
            <label
              htmlFor="select-fund"
              className="mb-1 ms-2 fw-semibold fs-12"
            >
              Select Asset
            </label>
            <div>
              <SBAComboBox
                data={AssetListDDL}
                textField="AssetName"
                valueField="AssetId"
                value={selectedAsset}
                onChange={AssestDDChanged}
                filterable={true}
              />
            </div>
          </div>

          <div className="col-md-4">
            <label htmlFor="from-date" className="mb-1 ms-2 fw-semibold fs-12">
              Date Range
            </label>
            <div className="">
              <SBDateRangePicker 
              value={{
                start: startDate ? moment(startDate).toDate() : new Date(),
                end:   endDate ? moment(endDate).toDate() : new Date(),
              }}
              onChange={handleDateChange}
              />
              {/* <DateRangePicker
                className="SbaDateRage text-dark"
                value={[
                  startDate ? moment(startDate).toDate() : new Date(),
                  endDate ? moment(endDate).toDate() : new Date(),
                ]}
                format="MM/dd/yyyy"
                onChange={handleDateChange}
                block
                character=" - "
              /> */}
            </div>
          </div>
          <div className="col-md-4">
            <label
              htmlFor="table-options"
              className="mb-1 ms-2 fw-semibold fs-12"
            >
              Data Table Options
            </label>
            <div className="d-flex align-items-center">
              <div className="form-check">
                <input
                  type="radio"
                  className="form-check-input"
                  name="table-options"
                  id="include"
                  value="include"
                  defaultChecked={selectedOption === true}                />
                <label htmlFor="include" className="form-check-label">
                  Include
                </label>
              </div>
              <div className="form-check ms-3">
                <input
                  type="radio"
                  className="form-check-input"
                  name="table-options"
                  id="exclude"
                  value="exclude"
                  disabled={true}
                />
                <label htmlFor="exclude" className="form-check-label">
                  Exclude
                </label>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-3">
          <button 
            type="button" 
            className="cancel-btn"
            onClick={clearButtonClick}
          >
            Clear All
          </button>
          <button
            type="button"
            className="enter-btn ms-2"
            onClick={()=>{enterButtonClick()}}
          >
            Enter
          </button>
        </div>
      </form>

          <br></br>
          <div>
       {sectorChartSeriesData.length !== 0 ? (
              <div>
      {widgetView ? (
        <div>
          <p>
            <b>13F Charts</b>
          </p>

          <div id="content" className="dashboard">
            <TileLayout
              columns={4}
              rowHeight={255}
              positions={data}
              gap={{
                rows: 10,
                columns: 10,
              }}
              items={tiles}
              onReposition={handleReposition}
            />
          </div>
        </div>
      ) : (
        <> </>
              )}

              </div>
              ) : (
              <div class="card-body">
                  No Data Available
              </div>
          )}
          </div>
    </>
  );
};
